<template>
    <div id="gifty-container" :class="this.$root.settings.position">
        <!--<transition appear name="bounce" v-if="visible">-->
        <vue-iframe id="gifty-widget" v-if="visible" cssFile="app" :class="this.$root.settings.position">
            <widget
                :settings="this.$root.settings"
                ref="widget"
                :order-manager="this.orderManager"
                :initial-processing-order-status="this.processingOrderStatus"
                :initial-processing-order-id="this.processingOrderId"
            >
            </widget>
        </vue-iframe>
        <!--</transition>-->


        <transition appear name="slide-in" v-if="showToggle">
            <div id="gifty-toggle-container" :class="this.$root.settings.position"
                 :style="{background: this.$root.settings.toggle_color}">
                <vue-iframe id="gifty-toggle" cssFile="toggle">
                    <button id="toggle" @click="toggleWidget" :style="{background: this.$root.settings.toggle_color}">
                        <i class="icon-giftcard" :style="{color: this.$root.settings.toggle_foreground_color}"></i>
                    </button>
                </vue-iframe>
            </div>
        </transition>

        <transition appear name="slide-in" v-if="showToggle">
            <div id="gifty-toast-container" v-show="showToast" :class="this.$root.settings.position">
                <vue-iframe id="gifty-toast" cssFile="toast">
                    <Toast @toggle="toggleToast" :settings="this.$root.settings"/>
                </vue-iframe>
            </div>
        </transition>
    </div>
</template>

<script>
import VueIframe from './components/VueIframe.vue';
import Widget from './components/Widget.vue';
import Toast from './components/Toast.vue';
import FacebookPixelPlugin from './plugins/FacebookPixelPlugin.js';
import GoogleTagManagerPlugin from './plugins/GoogleTagManagerPlugin.js';
import GoogleAdsPlugin from './plugins/GoogleAdsPlugin.js';

export default {
    data() {
        return {
            processingOrderId: null,
            processingOrderStatus: null,
            visible: false,
            showToast: false,
            plugins: [],
        };
    },

    props: {
        orderManager: {
            type: Object,
            required: true,
        },
    },

    components: {
        VueIframe,
        Widget,
        Toast,
    },

    methods: {
        toggleWidget() {
            window.Gifty.EventBus.$emit('widget-toggle');
        },
        setVisible(value) {
            window.Gifty.stateString = value ? 'open' : 'closed';
            this.visible = value;
        },
        toggleToast(newValue = !this.showToast) {
            this.showToast = newValue;
        },
    },

    computed: {
        showToggle() {
            if (typeof window.Gifty.trigger === 'undefined') {
                return true;
            }
            return window.Gifty.trigger;
        },
    },

    async beforeMount() {
        const debug = window.Gifty.debug;

        // Initialize order management
        const { processingOrderId, processingOrderStatus } = await this.orderManager.initialize();

        if (processingOrderId && processingOrderStatus) {
            this.processingOrderId = processingOrderId;
            this.processingOrderStatus = processingOrderStatus;
            this.setVisible(true)
        }

        // Initialize plugins
        if (window.Gifty.fbq === true) {
            const fbPixelPlugin = new FacebookPixelPlugin(this.$root.settings.company_id, debug);
            if (fbPixelPlugin.initialize()) {
                this.plugins.push(fbPixelPlugin);
            }
        } else {
            debug.log('info', 'Facebook Pixel tracking is not active');
        }

        if (window.Gifty.gtag === true) {
            const gtmPlugin = new GoogleTagManagerPlugin(this.$root.settings.company_id, debug);
            if (gtmPlugin.initialize()) {
                this.plugins.push(gtmPlugin);
            }
        } else {
            debug.log('info', 'Google Tag Manager tracking is not active');
        }

        if(typeof window.Gifty.gads !== 'undefined' && window.Gifty.gads !== false) {
            const gadsPlugin = new GoogleAdsPlugin(this.$root.settings.company_id, debug);
            if(gadsPlugin.initialize()) {
                this.plugins.push(gadsPlugin);
            }
        } else {
            debug.log('info', 'Google Ads tracking is not active');
        }

        // Setup test confirmation if needed
        await debug.setupTestConfirmation(this.plugins);
    },

    mounted() {
        const debug = window.Gifty.debug;

        // Set up event listeners
        window.Gifty.EventBus.$on('widget-toggle', () => {
            this.setVisible(!this.visible);
            debug.log('event', `Widget toggled: ${this.visible ? 'opened' : 'closed'}`);
        });

        window.Gifty.EventBus.$on('widget-open', () => {
            this.setVisible(true);
            debug.log('event', 'Widget opened');
        });

        window.Gifty.EventBus.$on('widget-close', () => {
            this.setVisible(false);
            debug.log('event', 'Widget closed');
        });

        window.Gifty.EventBus.$on('add-to-cart', async (product) => {
            this.setVisible(true);
            debug.log('event', 'Add to cart triggered', product);
            await this.$nextTick();
            window.Gifty.EventBus.$emit('internal-add-to-cart', product);
        });

        window.Gifty.EventBus.$on('shop-viewed', () => {
            this.plugins.forEach(plugin => plugin.onShopViewed());
        });

        window.Gifty.EventBus.$on('product-added', (product) => {
            this.plugins.forEach(plugin => plugin.onProductAdded(product));
        });

        window.Gifty.EventBus.$on('order-confirmation', (order) => {
            this.plugins.forEach(plugin => plugin.onOrderConfirmation(order));
        });
    },
};
</script>
